module.exports = __webpack_public_path__ + "img/Bjornson_Den_allsidige_Bjornstrjerne_Bjornson.69885ee1.jpg";